class ComponentHeroHeader {
  private searchBar?: HTMLElement | null;

  private stickyClass = 'fixed';
  private initialOffsetTop: number = 0;

  constructor() {
    if (window.innerWidth < 768) {
      this.searchBar = document.getElementById('search-bar');

      if (this.searchBar) {
        this.initialOffsetTop = this.searchBar.offsetTop;
        this._init();
      }
    }
  }

  private _init() {
    window.addEventListener('scroll', this._handleScroll.bind(this));
  }

  private _handleScroll() {


    if (!this.searchBar) return;

    window.addEventListener('scroll', () => {
      const header = document.querySelector('.header-primary__mobile') as HTMLElement;

      if (header && this.searchBar) {
        const headerRect = header.getBoundingClientRect();
        const searchBarRect = this.searchBar.getBoundingClientRect();

        if (headerRect.bottom >= searchBarRect.top) {
          this.searchBar.classList.add(this.stickyClass);
        } else {
          this.searchBar.classList.remove(this.stickyClass);
        }
      }
    });
  }
}

export const componentHeroHeader = new ComponentHeroHeader();
